import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.pad-start";
import "core-js/modules/es.string.trim";
import _typeof from "/Users/suifeng/Desktop/projects/2026/QianKunLong/QklAdmin/node_modules/@babel/runtime/helpers/esm/typeof";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { monthSettleList, monthSettleSend, monthSettleImport, monthSettleDelete } from '@/api/apis';
import tableExcelSelect from '@/components/rw/tempTable/components/tableExcelSelect';
export default {
  name: 'mothSend',
  components: {
    tableExcelSelect: tableExcelSelect
  },
  data: function data() {
    return {
      loading: false,
      selectedExpect: '',
      searchNumber: '',
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      selectedRows: [],
      importedNumbers: [],
      exportModel: [{
        show: 1,
        label: '会员编号',
        prop: 'to_number'
      }, {
        show: 1,
        label: '姓名',
        prop: 'real_name'
      }, {
        show: 1,
        label: '手机号',
        prop: 'phone'
      }, {
        show: 1,
        label: '等级',
        prop: 'grade'
      }, {
        show: 1,
        label: '资格',
        prop: 'level'
      }, {
        show: 1,
        label: '笔数',
        prop: 'count'
      }, {
        show: 1,
        label: '奖金额',
        prop: 'bonus'
      }, {
        show: 1,
        label: '管理税',
        prop: 'tax_manage'
      }, {
        show: 1,
        label: '复销税',
        prop: 'tax_fx'
      }, {
        show: 1,
        label: '发放金额',
        prop: 'send_money'
      }, {
        show: 1,
        label: '当月市场报单金额',
        prop: 'market_price'
      }, {
        show: 1,
        label: '当月市场报单业绩',
        prop: 'market_pv'
      }, {
        show: 1,
        label: '当月小区新增报单金额',
        prop: 'month_small_price'
      }, {
        show: 1,
        label: '累计小区报单金额',
        prop: 'total_small_price'
      }]
    };
  },
  computed: {
    importedCount: function importedCount() {
      return this.importedNumbers.length;
    },
    filteredData: function filteredData() {
      var _this = this;

      var result = this.tableData;

      if (this.searchNumber) {
        result = result.filter(function (item) {
          return item.to_number && item.to_number.includes(_this.searchNumber);
        });
      }

      return result;
    },
    pagedData: function pagedData() {
      return this.filteredData;
    }
  },
  mounted: function mounted() {
    this.selectedExpect = this.getCurrentMonth();
    this.loadData();
  },
  methods: {
    // 获取当前月份
    getCurrentMonth: function getCurrentMonth() {
      var d = new Date();
      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
    },
    // 解析行数据，展开 remark 字段
    mapRows: function mapRows(rows) {
      return (rows || []).map(function (r) {
        var rm = {};

        if (r.remark) {
          try {
            rm = _typeof(r.remark) === 'object' ? r.remark : JSON.parse(r.remark);
          } catch (e) {
            rm = {};
          }
        }

        r.market_price = rm.marketPrice;
        r.market_pv = rm.marketPv;
        r.month_small_price = rm.monthSmallPrice;
        r.total_small_price = rm.totalSmallPrice;
        return r;
      });
    },
    // 加载发放名单
    loadData: function loadData() {
      var _this2 = this;

      if (!this.selectedExpect) return;
      this.loading = true; // TODO: 替换为真实接口

      monthSettleList({
        page: this.currentPage,
        limit: this.pageSize,
        month: this.selectedExpect
      }).then(function (res) {
        var data = res && res.data ? res.data : res;
        var rows = data && data.rows || [];
        _this2.tableData = _this2.mapRows(rows);
        _this2.total = data && data.count ? data.count : rows.length || 0;
        _this2.loading = false;
      }).catch(function () {
        _this2.tableData = [];
        _this2.loading = false;
      });
    },
    // 搜索
    onSearch: function onSearch() {
      this.currentPage = 1;
    },
    onReset: function onReset() {
      this.searchNumber = '';
      this.importedNumbers = [];
      this.currentPage = 1;
    },
    onSizeChange: function onSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.loadData();
    },
    onPageChange: function onPageChange(page) {
      this.currentPage = page;
      this.loadData();
    },
    onSelectionChange: function onSelectionChange(rows) {
      this.selectedRows = rows;
    },
    // 单个发放
    onSingleSend: function onSingleSend(row) {
      var _this3 = this;

      this.$confirm("\u786E\u8BA4\u5BF9\u4F1A\u5458\u300C".concat(row.to_number, "\u300D\u53D1\u653E\u6708\u7ED3\u7B97\u5956\u52B1\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        monthSettleSend({
          to_number: [row.to_number],
          month: _this3.selectedExpect
        }).then(function (res) {
          _this3.$message({
            message: '发放成功',
            type: 'success'
          });

          _this3.loadData();
        });
      }).catch(function () {});
    },
    // 批量发放
    onBatchSend: function onBatchSend() {
      var _this4 = this;

      if (this.selectedRows.length === 0) {
        this.$message({
          message: '请选择要发放的会员',
          type: 'warning'
        });
        return;
      }

      this.$confirm("\u786E\u8BA4\u5BF9\u9009\u4E2D\u7684 ".concat(this.selectedRows.length, " \u4F4D\u4F1A\u5458\u53D1\u653E\u6708\u7ED3\u7B97\u5956\u52B1\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        monthSettleSend({
          to_number: _this4.selectedRows.map(function (r) {
            return r.to_number;
          }),
          month: _this4.selectedExpect
        }).then(function (res) {
          _this4.$message({
            message: "\u5DF2\u53D1\u653E ".concat(_this4.selectedRows.length, " \u4EBA"),
            type: 'success'
          });

          _this4.loadData();
        });
      }).catch(function () {});
    },
    // 全部发放
    onSendAll: function onSendAll() {
      var _this5 = this;

      if (this.tableData.length === 0) {
        this.$message({
          message: '没有待发放的会员',
          type: 'warning'
        });
        return;
      }

      this.$confirm("\u786E\u8BA4\u5BF9\u5168\u90E8 ".concat(this.tableData.length, " \u4F4D\u4F1A\u5458\u53D1\u653E\u6708\u7ED3\u7B97\u5956\u52B1\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        monthSettleSend({
          to_number: _this5.tableData.map(function (r) {
            return r.to_number;
          }),
          month: _this5.selectedExpect
        }).then(function (res) {
          _this5.$message({
            message: '全部发放成功',
            type: 'success'
          });

          _this5.loadData();
        });
      }).catch(function () {});
    },
    // 清空未发放奖金
    onClearUnsent: function onClearUnsent() {
      var _this6 = this;

      this.$confirm("\u786E\u8BA4\u6E05\u7A7A\u300C".concat(this.selectedExpect, "\u300D\u5168\u90E8\u672A\u53D1\u653E\u7684\u6708\u7ED3\u7B97\u5956\u91D1\uFF1F"), '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'danger'
      }).then(function () {
        // TODO: 替换为真实接口
        monthSettleDelete({
          month: _this6.selectedExpect
        }).then(function (res) {
          _this6.$message({
            message: '已清空未发放奖金',
            type: 'success'
          });

          _this6.loadData();
        });
      }).catch(function () {});
    },
    // 导出Excel
    onExport: function onExport() {
      var _this7 = this;

      var title = '月结算奖励名单-' + this.selectedExpect;
      this.$refs['excel'].show(title, this.exportModel, function (ret, tag, model) {
        if (!ret) return;
        var columns = model.filter(function (item) {
          return item.show === 1;
        });

        if (columns.length === 0) {
          _this7.$message({
            message: '请至少勾选一个导出字段',
            type: 'warning'
          });

          return;
        }

        _this7.$g.fun.startLoading();

        _this7.getExportData(tag).then(function (data) {
          _this7.$export.excel({
            columns: columns,
            data: data,
            title: title
          }).then(function () {
            _this7.$g.fun.endLoading();
          });
        }).catch(function () {
          _this7.$g.fun.endLoading();
        });
      });
    },
    getExportData: function getExportData(isAll) {
      var _this8 = this;

      if (isAll === 0) {
        return Promise.resolve(this.filteredData);
      }

      return monthSettleList({
        page: 1,
        limit: 1000000,
        month: this.selectedExpect
      }).then(function (res) {
        var data = res && res.data ? res.data : res;

        var rows = _this8.mapRows(data && data.rows || []);

        if (_this8.searchNumber) {
          rows = rows.filter(function (item) {
            return item.to_number && item.to_number.includes(_this8.searchNumber);
          });
        }

        return rows;
      });
    },
    // 下载导入模版
    onDownloadTemplate: function onDownloadTemplate() {
      this.$export.excel({
        columns: [{
          label: '会员编号',
          prop: 'to_number'
        }],
        data: [],
        title: '月结算导入模版'
      });
    },
    // 导入Excel
    onImport: function onImport() {
      this.$refs.importInput.value = null;
      this.$refs.importInput.click();
    },
    onExcelImport: function onExcelImport(event) {
      var _this9 = this;

      var file = event.target.files[0];
      this.$import.xlsx(file).then(function (_ref) {
        var header = _ref.header,
            results = _ref.results;
        var numbers = [];

        try {
          for (var i in results) {
            var item = results[i];
            var num = item['会员编号'] || item['编号'] || item['number'];
            if (num) numbers.push(num.toString().trim());
          }

          _this9.importedNumbers = numbers; // 标记导入的会员
          // TODO: 上传到后端定义发放范围

          monthSettleImport({
            numbers: numbers
          }).then(function (res) {
            _this9.$message({
              message: "\u5DF2\u5BFC\u5165 ".concat(numbers.length, " \u4EBA\u540D\u5355"),
              type: 'success'
            });

            var data = res && res.data ? res.data : res;
            var rows = data && data.rows || [];
            _this9.tableData = _this9.mapRows(rows);
            _this9.total = data && data.count ? data.count : rows.length || 0;
            _this9.currentPage = 1;
          }).catch(function () {
            _this9.$message({
              message: "\u5DF2\u5BFC\u5165 ".concat(numbers.length, " \u4EBA\u540D\u5355\uFF08\u672C\u5730\u6807\u8BB0\uFF09"),
              type: 'success'
            });
          });
        } catch (err) {
          _this9.$message({
            message: '表格格式错误，请确保包含「会员编号」列',
            type: 'error'
          });
        }
      });
    }
  }
};